import { render, staticRenderFns } from "./CommService.vue?vue&type=template&id=5dd835a5&scoped=true&"
import script from "./CommService.vue?vue&type=script&lang=js&"
export * from "./CommService.vue?vue&type=script&lang=js&"
import style0 from "./CommService.vue?vue&type=style&index=0&id=5dd835a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd835a5",
  null
  
)

export default component.exports